export const RELEASE_PUBLISH = 'RELEASE_PUBLISH';

export const releasePublish = (payload) => ({
  type: RELEASE_PUBLISH,
  payload,
});
